<template>
  <form class="flow">
    <ul class="steps-desktop">
      <li
        v-for="(step, index) in stepsData"
        :key="index"
        :class="{ active: index == activeStep }"
      >
        {{ step }}
      </li>
    </ul>

    <div class="steps-mobile">
      <p class="title">
        {{ stepsData[activeStep] }}
      </p>
      <p class="count">
        {{ translation.step }} {{ activeStep + 1 }} /
        {{ stepsData.length }}
      </p>
    </div>

    <p v-if="!success">{{ text_top }}</p>

    <div class="wrapper">
      <input type="hidden" id="gclid_field" name="gclid_field" value="" />

      <input type="hidden" id="cid_field" name="cid" value="" />

      <div :class="type" v-if="!success">
        <transition name="slide" mode="out-in">
          <div class="step" v-if="activeStep === 0" key="0">
            <slot name="step-0"></slot>

            <button @click.prevent="next('form-1')">
              {{ translation.next }}
            </button>
          </div>

          <div class="step" v-if="activeStep === 1" key="1">
            <slot name="step-1"></slot>

            <button type="button" @click.prevent="prev()">
              {{ translation.prev }}
            </button>
            <button @click.prevent="next('form-2')">
              {{ translation.next }}
            </button>
          </div>

          <div class="step" v-if="activeStep === 2" key="2">
            <slot name="step-2"></slot>

            <div class="terms">
              <div class="checkbox-wrapper">
                <input
                  v-model="agreed_terms.status"
                  type="checkbox"
                  name="conditions"
                  id="flow-conditions"
                />
                <a :href="terms" target="_blank">
                  {{ this.$translations.cart.terms_text }}
                </a>
              </div>
              <div class="form-error" v-if="agreed_terms.error">
                {{ this.$translations.cart.terms_error }}
              </div>
            </div>

            <button type="button" @click.prevent="prev()">
              {{ translation.prev }}
            </button>

            <button
              :class="['btn-submit', type, { 'btn-loading': loading }]"
              type="submit"
              @click.prevent="submit()"
            >
              <span v-if="loading">{{ translation.sending }}...</span>
              <span v-else>{{ translation.send }}</span>
            </button>
          </div>
        </transition>
      </div>

      <div class="form-success" v-if="success">
        <p class="title">
          {{ this.$translations.form.post_success_one }}
        </p>
        <div class="text">
          {{ this.$translations.form.post_success_two }}
        </div>
        <div class="icon">
          <div>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="far"
              data-icon="check-circle"
              class="svg-inline--fa fa-check-circle fa-w-16"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
              ></path>
            </svg>
          </div>
        </div>

        <button class="reset" @click.prevent="reset()">
          {{ translation.reset }}
        </button>
      </div>

      <p class="form-error" v-show="error">
        {{ translation.error_general }}
      </p>
    </div>

    <p v-if="!success">{{ text_bottom }}</p>
  </form>
</template>

<script>
import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import axios from "axios";

Vue.use(VeeValidate);

export default {
  props: {
    steps: { required: true, type: String },
    text_top: { required: false, type: String },
    text_bottom: { required: false, type: String },
    type: { required: false, type: String },
    form: { required: true, type: Object },
    terms: { required: true, type: String },
  },
  data() {
    return {
      loading: false,
      translation: this.$translations.form,
      activeStep: 0,
      submitted: false,
      error: false,
      success: false,
      files_error: false,
      agreed_terms: {
        status: false,
        error: false,
      },
    };
  },
  computed: {
    stepsData() {
      return this.steps.split(",");
    },
  },
  methods: {
    prev() {
      if (this.activeStep !== 0) {
        this.activeStep--;
      }
    },
    next(scope) {
      this.$emit("validate", scope);
    },
    reset() {
      this.$emit("reset");
      this.success = false;
      this.activeStep = 0;
      this.submitted = false;
      this.error = false;
    },
    async submit() {
      this.submitted = true;
      await this.$emit("submit", "form-3");
    },
    async send(form, type) {
      this.loading = true;

      form.append("agreed", this.agreed_terms.status ? "agreed" : "not agreed");

      let url =
        type == "sell"
          ? "https://mailer.signifly.com/api/klassik-sell/mail"
          : "https://mailer.signifly.com/api/klassik/mail";

      if (this.agreed_terms.status) {
        await axios
          .post(url, form, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.submitted = false;
            this.success = true;
            this.loading = false;
          })
          .catch((e) => {
            this.submitted = false;
            this.error = true;
          });
      } else {
        this.agreed_terms.error = true;
      }
      this.success = true;
    },
  },
};
</script>

<style lang="scss" scoped>
form.flow {
  .wrapper {
    margin: 40px 0;
  }

  .steps-desktop {
    list-style: none;
    display: flex;
    justify-content: space-between;

    @include res(tab-p) {
      display: none;
    }

    li {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding: 0 34px;
      height: 40px;
      position: relative;
      background-color: #eeeeee;
      font-family: $font-heading;
      color: $brown;
      text-transform: uppercase;

      &:not(:first-of-type)::before {
        content: " ";
        position: absolute;
        left: 0px;
        top: 0;
        z-index: 0;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 20px 0 20px 22px;
        border-color: transparent transparent transparent #ffffff;
        line-height: 0px;
        _border-color: #000000 #000000 #000000 #ffffff;
        _filter: progid:DXImageTransform.Microsoft.Chroma(color='#000000');
      }

      &:not(:last-of-type):after {
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        right: -22px;
        border-style: solid;
        border-width: 20px 0 20px 22px;
        border-color: transparent transparent transparent #eeeeee;
        z-index: 10;
        top: 0;
      }

      &.active:not(:last-of-type):after {
        border-color: transparent transparent transparent $brown;
      }

      &.active {
        background-color: $brown;
        color: #eeeeee;
      }
    }
  }

  .steps-mobile {
    display: none;

    @include res(tab-p) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
    }

    .title {
      font-size: 18px;
      color: $brown;
      font-family: $font-heading;
      margin: 0;
      text-align: center;
    }

    .count {
      font-style: 14px;
      margin: 0;
      margin-bottom: 16px;
      text-align: center;
    }
  }

  .step {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: baseline;
    font-family: $font-text;

    button,
    input[type="submit"] {
      @include button(#ffffff, 15px, 20px);
      line-height: 20px;
      background-color: $dark-grey;
      border: 0;
      max-width: calc(50% - 10px);
      width: 100%;

      &::before {
        @include button-hover($bg: #5C5C5C);
      }

      @include res(tab-p) {
        margin-bottom: 8px;
      }
    }
  }

  .terms {
    @include terms;
  }

  .reset {
    @include button(#ffffff, 15px, 20px);
    line-height: 20px;
    background-color: $dark-grey;
    border: 0;
    max-width: calc(50% - 10px);
    width: 100%;
    display: block;
    margin: 32px auto 0;

    &::before {
      @include button-hover($bg: #5C5C5C);
    }

    @include res(tab-p) {
      margin-bottom: 8px;
    }
  }

  .form-error {
    margin-top: 8px;
  }

  .form-success {
    @include res(tab-p) {
      padding: 30px 0px;
    }

    .title {
      color: $vintage;
      font-size: 34px;
      text-align: center;
      font-family: $font-heading;
      line-height: 44px;

      @include res(tab-p) {
        font-size: 26px;
      }
    }

    .text {
      font-family: $font-text;
      color: $dark-grey;
      text-align: center;
      font-size: 16px;
    }

    .icon {
      max-width: 45px;
      height: auto;
      margin: 32px auto 0;

      svg {
        fill: $brown;
      }
    }
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: 0.5s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: translate(-40px, 0);
}

.slide-move {
  display: none;
}
</style>
